// src/components/AdminLayout.js
import React from 'react';

const bs = { fontFamily: "'Montserrat', sans-serif" };
const ds = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

const AdminLayout = ({ children }) => {
  return (
    <div style={{ minHeight: '100vh', background: '#f8f5f5', ...bs }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300&family=Montserrat:wght@300;400;500;600&display=swap');
      `}</style>

      {/* Header */}
      <header style={{
        background: '#060D14', position: 'sticky', top: 0, zIndex: 50,
        borderBottom: '1px solid rgba(255,255,255,0.04)',
      }}>
        <div style={{
          maxWidth: '1400px', margin: '0 auto',
          padding: '0 24px', height: '60px',
          display: 'flex', alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          {/* Logo */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img src="/logo-elede.png" alt="ELEDÉ"
              style={{ height: '28px', opacity: 0.9 }} />
            <div>
              <span style={{ ...ds, color: 'white', fontSize: '18px',
                fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase' }}>
                ELEDÉ
              </span>
              <span style={{ ...bs, color: 'rgba(255,255,255,0.3)', fontSize: '9px',
                letterSpacing: '0.25em', textTransform: 'uppercase',
                marginLeft: '10px', verticalAlign: 'middle' }}>
                Admin
              </span>
            </div>
          </div>

          {/* Indicador de sesión */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ width: '7px', height: '7px', borderRadius: '50%',
              background: '#22c55e' }} />
            <span style={{ ...bs, color: 'rgba(255,255,255,0.4)', fontSize: '10px',
              letterSpacing: '0.12em', textTransform: 'uppercase' }}>
              Sesión activa
            </span>
          </div>
        </div>
      </header>

      {/* Contenido */}
      <main style={{ maxWidth: '1400px', margin: '0 auto', padding: '0' }}>
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
